import mod from "-!./Dashboard.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Dashboard.js?vue&type=script&lang=js&"